import React from 'react';
import { Table, LoadingSpinner } from 'edenred-ui';

import { LoadRequestsTableProps } from '@epi-models/pages/Reports';

import { TableNoContent } from '../../TableNoContent';

import { LoadRequestsTableHead } from './LoadRequestsTableHead';
import { LoadRequestsTableBody } from './LoadRequestsTableBody';

export const LoadRequestsTable = ({
  loadRequests,
  isLoading
}: LoadRequestsTableProps) => {
  if (isLoading) return <LoadingSpinner />;

  return (
    <Table>
      <Table.Head>
        <LoadRequestsTableHead />
      </Table.Head>
      <Table.Body>
        {loadRequests.length ? (
          <LoadRequestsTableBody loadRequests={loadRequests} />
        ) : (
          <TableNoContent colSpan={8} />
        )}
      </Table.Body>
    </Table>
  );
};
